import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled(Icon)`
  font-size: 2rem;
`;
